// The loader's CSS, inlined into widget.js (and published as widget.css for browsers without constructable
// stylesheets).
import css from './loader.css?inline';

export const LOADER_CSS = css;
